import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "../utils/interceptor";

// Generate Single QR Code
export const generateQRCodeService = (data: {
  plan_type: number;
  duration: number;
  coins: number;
  price: number;
  status?: number;
  expires_at?: string;
}) => {
  return HTTP_CLIENT.post(Endpoint.product_manager.qrCodeGenerate, data);
};

// Generate Bulk QR Codes
export const generateBulkQRCodeService = (data: {
  event_name: string;
  plan_type: number;
  duration: number;
  coins: number;
  price: number;
  quantity: number;
  status?: number;
  expires_at?: string;
}) => {
  return HTTP_CLIENT.post(Endpoint.product_manager.qrCodeGenerateBulk, data);
};

// Get QR Codes List
export const getQRCodesListService = (params?: {
  event_name?: string;
  status?: number | string;
  is_used?: number | string;
  plan_type?: number;
  search?: string;
  sort_by?: string;
  sort_order?: string;
  per_page?: number;
  page?: number;
}) => {
  const queryParams = new URLSearchParams();

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        queryParams.append(key, value.toString());
      }
    });
  }

  const url = `${Endpoint.product_manager.qrCodeList}${
    queryParams.toString() ? `?${queryParams.toString()}` : ""
  }`;

  return HTTP_CLIENT.get(url);
};

// Get All Event Names
export const getEventNamesService = () => {
  return HTTP_CLIENT.get(Endpoint.product_manager.qrCodeEvents);
};

// Get QR Code Statistics
export const getQRCodeStatisticsService = () => {
  return HTTP_CLIENT.get(Endpoint.product_manager.qrCodeStatistics);
};

// Activate QR Code
export const activateQRCodeService = (id: number) => {
  return HTTP_CLIENT.post(`${Endpoint.product_manager.qrCodeActivate}${id}`);
};

// Deactivate QR Code
export const deactivateQRCodeService = (id: number) => {
  return HTTP_CLIENT.post(`${Endpoint.product_manager.qrCodeDeactivate}${id}`);
};

// Delete QR Code
export const deleteQRCodeService = (id: number) => {
  return HTTP_CLIENT.post(`${Endpoint.product_manager.qrCodeDelete}${id}`);
};

// Download Single QR Code
export const downloadSingleQRCodeService = (id: number) => {
  return HTTP_CLIENT.get(`${Endpoint.product_manager.qrCodeDownloadSingle}${id}`);
};

// Download QR Codes by Event
export const downloadEventQRCodesService = (eventName: string) => {
  return HTTP_CLIENT.get(
    `${Endpoint.product_manager.qrCodeDownloadEvent}${encodeURIComponent(eventName)}`,
    {
      responseType: "blob",
      timeout: 300000, // 5 minutes for bulk download operations
    }
  );
};

// Download All QR Codes
export const downloadAllQRCodesService = (
  params?: {
    event_name?: string;
    status?: number | string;
    is_used?: number | string;
    plan_type?: number;
    search?: string;
  },
  onProgress?: (progressEvent: any) => void
) => {
  const queryParams = new URLSearchParams();

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        queryParams.append(key, value.toString());
      }
    });
  }

  const url = `${Endpoint.product_manager.qrCodeDownloadAll}${
    queryParams.toString() ? `?${queryParams.toString()}` : ""
  }`;

  return HTTP_CLIENT.get(url, {
    responseType: "blob",
    timeout: 300000, // 5 minutes for bulk download operations
    onDownloadProgress: onProgress,
    // Prevent axios from setting max content length
    maxContentLength: Infinity,
    maxBodyLength: Infinity,
  });
};
